export const colors = {
  // ✅ Main Theme Colors
  navy: '#001F3F', // Navy (Sidebar + Buttons + Text accents)
  veryLightGreen: '#F3FFF5', // Very Light Green (Right background)
  lightBlue: '#ADD8E6', // Light Blue (Hero gradient + icons background)
  
  // Brand / Primary - Using Navy
  primary: '#001F3F', // Navy
  primaryHover: '#012a55', // Darker navy on hover
  primarySoft: '#ADD8E6', // Light blue for soft elements
  
  // Accent - Light Blue
  accentGold: '#ADD8E6', // Light blue accent
  accentSoft: 'rgba(173,216,230,0.65)', // Light blue accent background
  
  // Background / Surface - Very Light Green theme
  appBg: '#F3FFF5', // Very light green background
  cardBg: 'rgba(255,255,255,0.75)', // Card glass background
  sectionBg: 'rgba(255,255,255,0.78)', // White glass background
  
  // Text Colors
  title: '#0B2239', // Main Text (dark)
  body: '#0B2239', // Main Text (dark)
  muted: '#5C6A7A', // Muted Text (gray)
  
  // Borders - Glass effect
  border: 'rgba(0,0,0,0.05)', // Soft border
  borderIcon: 'rgba(0,0,0,0.06)', // Icon / Button border
  
  // Sidebar - Navy gradient
  sidebarGradientStart: '#001F3F',
  sidebarGradientEnd: '#012a55',
  
  // Sidebar UI Colors (Transparent / Glass effect)
  sidebarHoverBg: 'rgba(255,255,255,0.12)', // Sidebar hover background
  sidebarActiveBg: 'rgba(255,255,255,0.18)', // Sidebar active background
  sidebarActiveBorder: 'rgba(255,255,255,0.16)', // Sidebar active border
  
  // Shadows
  shadow: 'rgba(0,0,0,0.10)', // Main shadow
  shadowSoft: 'rgba(0,0,0,0.08)', // Soft shadow
  
  // Status Colors (keeping for consistency)
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#001F3F' // Using navy for info
};
